import {
  ContainerDirective,
  LeafDirective,
  TextDirective,
} from 'mdast-util-directive'
import { VFile } from 'vfile'

const processDownloadLink = (
  node: TextDirective | LeafDirective | ContainerDirective,
  index: number,
  parent: any,
  file: VFile
) => {
  const url = node?.attributes?.id

  // Require a `url` attribute, crash otherwise.
  if (typeof url !== 'string') {
    file.fail('Expected `id` attribute on download-link directive', node)
  }

  node.data = node.data ?? {}
  node.data.hName = 'div'
  node.data.hProperties = {
    className: 'download-link',
  }

  const downloadLink = {
    type: 'link',
    url: process.env.CONTENT_DOMAIN + url,
    children: [node.children[0]],
  }

  
  parent.children.splice(index, 1, downloadLink)
}
export default processDownloadLink
